module.exports = __webpack_public_path__ + "media/letter.a23f1c6d.wav";